// tslint:disable:variable-name

export class Token {
    protected constructor(public key: string) { }

    public static withKey(key: string): Token {
        let token = this[key] as Token;
        if (!token) token = new Token(key); // throw new Error(`Could not find token for key '${key}'`);
        return token;
    }

    // libraries
    public static AdminLib = new Token("adminLib");
    public static Creator = new Token("creator");
    public static HandsontableLib = new Token("handsontableLib");
    public static HighchartsLib = new Token("highchartsLib");
    public static MarkdownDeepLib = new Token("markdownDeepLib");
    public static MonacoLoaderLib = new Token("monacoLoaderLib");
    public static Recaptcha = new Token("Recaptcha");
    public static SnapLib = new Token("snapLib");
    public static Viewer = new Token("viewer");
    

    // angular built-ins
    public static $Animate = new Token("$animate");
    public static $Scope = new Token("$scope");
    public static $Location = new Token("$location");
    public static $Http = new Token("$http");
    public static $RootScope = new Token("$rootScope");
    public static $Timeout = new Token("$timeout");
    public static $Q = new Token("$q");
    public static $Window = new Token("$window");
    public static $Document = new Token("$document");
    public static $Filter = new Token("$filter");
    public static $Injector = new Token("$injector");
    public static $Interval = new Token("$interval");
    public static $TemplateCache = new Token("$templateCache");
    public static $TemplateRequest = new Token("$templateRequest");
    public static $Compile = new Token("$compile");
    public static $Sce = new Token("$sce");
    public static $Locale = new Token("$locale");
    public static $CookieStore = new Token("$cookieStore");
    public static $Sanitize = new Token("$sanitize");
    public static PromiseTracker = new Token("promiseTracker");
    public static $OcLazyLoad = new Token("$ocLazyLoad");

    // ui router
    public static $State = new Token("$state");
    public static $Transitions = new Token("$transitions");
    public static $StateParams = new Token("$stateParams");

    // resolves
    public static Model = new Token("model");
    public static ProductResolve = new Token("productResolve");
    public static Categories = new Token("categories");
    public static Header = new Token("header");
    public static SsoGroups = new Token("ssoGroups");

    // animations
    public static KbRise = new Token(".kb-rise");

    // components
    public static KbActionSelect = new Token("kbActionSelect");
    public static KbAllowFraction = new Token("kbAllowFraction");
    public static KbAtom = new Token("kbAtom");
    public static KbAttachments = new Token("kbAttachments");
    public static KbAutoComplete = new Token("kbAutoComplete");
    public static KbAvatar = new Token("kbAvatar");
    public static KbAvatarSelect = new Token("kbAvatarSelect");
    public static KbButton = new Token("kbButton");
    public static KbCheckbox = new Token("kbCheckbox");
    public static KbColorPicker = new Token("kbColorPicker");
    public static KbColumn = new Token("kbColumn");
    public static KbContent = new Token("kbContent");
    public static KbComments = new Token("kbComments");
    public static KbDataGrid = new Token("kbDataGrid");
    public static KbDatePicker = new Token("kbDatePicker");
    public static KbDropdown = new Token("kbDropdown");
    public static KbEdit = new Token("kbEdit");
    public static KbEllipsis = new Token("kbEllipsis");
    public static KbExpander = new Token("kbExpander");
    public static KbExpanderGroup = new Token("kbExpanderGroup");
    public static KbField = new Token("kbField");
    public static KbFieldControl = new Token("kbFieldControl");
    public static KbFocus = new Token("kbFocus");
    public static KbForm = new Token("kbForm");
    public static KbIcon = new Token("kbIcon");
    public static KbIf = new Token("kbIf");
    public static KbIfDelay = new Token("kbIfDelay");
    public static KbImageSelect = new Token("kbImageSelect");
    public static KbInclude = new Token("kbInclude");
    public static KbInfiniteScroll = new Token("kbInfiniteScroll");
    public static KbLabel = new Token("kbLabel");
    public static KbList = new Token("kbList");
    public static KbListItem = new Token("kbListItem");
    public static KbMarkdownViewer = new Token("kbMarkdownViewer");
    public static KbMax = new Token("kbMax");
    public static KbMediaList = new Token("kbMediaList");
    public static KbMediaManager = new Token("kbMediaManager");
    public static KbMediaSelect = new Token("kbMediaSelect");
    public static KbMediaViewer = new Token("kbMediaViewer");
    public static KbMenu = new Token("kbMenu");
    public static KbMenuItem = new Token("kbMenuItem");
    public static KbMin = new Token("kbMin");
    public static KbMoney = new Token("kbMoney");
    public static KbMultiAutoComplete = new Token("kbMultiAutoComplete");
    public static KbMultiSelect = new Token("kbMultiSelect");
    public static KbImageMultiSelect = new Token("kbImageMultiSelect");
    public static KbNumberbox = new Token("kbNumberbox");
    public static KbOption = new Token("kbOption");
    public static KbPage = new Token("kbPage");
    public static KbPageTitle = new Token("kbPageTitle");
    public static KbPassword = new Token("kbPassword");
    public static KbPrivacyPolicy = new Token("kbPrivacyPolicy");
    public static KbProgress = new Token("kbProgress");
    public static KbRadio = new Token("kbRadio");
    public static KbResize = new Token("kbResize");
    public static KbRipple = new Token("kbRipple");
    public static KbScope = new Token("kbScope");
    public static KbSearchGrid = new Token("kbSearchGrid");
    public static KbSelect = new Token("kbSelect");
    public static KbSfdcHeader = new Token("kbSfdcHeader");
    public static KbSlide = new Token("kbSlide");
    public static KbSlider = new Token("kbSlider");
    public static KbSpinner = new Token("kbSpinner");
    public static KbSpinnerElement = new Token("kbSpinnerElement");
    public static KbSrcOnError = new Token("kbSrcOnError");
    public static KbSvgViewer = new Token("kbSvgViewer");
    public static KbTab = new Token("kbTab");
    public static KbTabs = new Token("kbTabs");
    public static KbTextarea = new Token("kbTextarea");
    public static KbTextbox = new Token("kbTextbox");
    public static KbToggle = new Token("kbToggle");
    public static KbToggleButton = new Token("KbToggleButton");
    public static KbTooltip = new Token("kbTooltip");
    public static KbTransclude = new Token("kbTransclude");
    public static KbTree = new Token("kbTree");
    public static KbTreeNode = new Token("kbTreeNode");
    public static KbUiObject = new Token("kbUiObject");
    public static KbUpload = new Token("kbUpload");
    public static KbValidationMessages = new Token("kbValidationMessages");
    
    
    // filters
    public static AssetFilter = new Token("asset");
    public static BytesFilter = new Token("bytes");
    public static EnumFilter = new Token("enum");
    public static FileIconFilter = new Token("fileIcon");
    public static FileIdFilter = new Token("fileId");
    public static FxConvertFilter = new Token("fxConvert");
    public static GetFileExtensionFilter = new Token("getFileExtension");
    public static GetFilenameFilter = new Token("getFilename");
    public static HasRoleFilter = new Token("hasRole");
    public static IconFilter = new Token("icon");
    public static IsAdminOrCompanyAdminFilter = new Token("isAdminOrCompanyAdmin");
    public static KbCurrencyFilter = new Token("kbCurrency");
    public static KbDateTimeFilter = new Token("kbDateTime");
    public static KbDateFilter = new Token("kbDate");
    public static LeadTimeFilter = new Token("leadTime");
    public static LocFilter = new Token("loc");
    public static LogIconFilter = new Token("logIcon");
    public static MediaFilter = new Token("media");
    public static NotificationIconFilter = new Token("notificationIcon");
    public static NumberFormateFilter = new Token("numberFormat");
    public static ProfileImageFilter = new Token("profileImage");
    public static QuoteProductImageFilter = new Token("quoteProductImage");
    public static RangeFilter = new Token("range");
    public static RawTextFilter = new Token("rawText");
    public static ShadeFilter = new Token("shade");
    public static SmartColorFilter = new Token("smartColor");
    public static ThemeColorFilter = new Token("themeColor");
    public static ThumbFilter = new Token("thumb");
    public static TruncateFilter = new Token("truncate");
    public static TrustAsHtmlFilter = new Token("trustAsHtml");

    // interceptors
    public static CacheBusterInterceptor = new Token("cacheBusterInterceptor");
    public static ErrorInterceptor = new Token("errorInterceptor");
    public static SecurityInterceptor = new Token("securityInterceptor");

    // services
    public static ApiService = new Token("apiService");
    public static AuthService = new Token("authService");
    public static Base64Service = new Token("base64Service");
    public static BundleLoaderService = new Token("bundleLoaderService");
    public static ClaraSceneService = new Token("claraSceneService");
    public static CrudService = new Token("crudService");
    public static DialogService = new Token("dialogService");
    public static DrawerService = new Token("drawerService");
    public static KbService = new Token("kbService");
    public static QuoteService = new Token("quoteService");
    public static RuleService = new Token("ruleService");
    public static SearchService = new Token("searchService");
    public static SecurityRetryService = new Token("securityRetryService");
    public static SfdcService = new Token("sfdcService");
    public static SignalRService = new Token("signalRService");
    public static StorageService = new Token("storageService");
    public static TelemetryService = new Token("telemetryService");
    public static ThemeService = new Token("themeService");
    public static UploadService = new Token("uploadService");
    public static InteractionService = new Token("interactionService");

    // views
    public static ContactView = new Token("contactView");
    public static ContactsView = new Token("contactsView");
    public static CrudView = new Token("crudView");
    public static CustomerView = new Token("customerView");
    public static CustomersView = new Token("customersView");
    public static DialogView = new Token("dialogView");
    public static NotificationsView = new Token("notificationsView");
    public static DrawerView = new Token("drawerView");
    public static LoginView = new Token("loginView");
    public static PortalView = new Token("portalView");
    public static PrivacyPolicyView = new Token("privacyPolicyView");
    public static ConfiguratorView = new Token("configuratorView");
    public static ProductView = new Token("productView");
    public static ProductsView = new Token("productsView");
    public static ProductCompareView = new Token("productCompareView");
    public static ConfiguredProductsView = new Token("configuredProductsView");
    public static QuoteView = new Token("quoteView");
    public static QuotesView = new Token("quotesView");
    public static SceneEmbedView = new Token("sceneEmbedView");
    public static SearchView = new Token("searchView");
    public static ChangePasswordView = new Token("changePasswordView");
    public static UserActivationView = new Token("userActivationView");
    public static UserView = new Token("userView");
}
